(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    class SectionArrowsNavigation {
    constructor(container) {
      this.container = container;
      this.wrapper = container.closest('.custom-section-content');
      this.prevButton = this.wrapper.querySelector('[data-arrow="prev"]');
      this.nextButton = this.wrapper.querySelector('[data-arrow="next"]');
      this.currentIndex = 0;
      
      if (!this.prevButton || !this.nextButton) return;
      
      this.init();
    }

    init() {
      this.updateArrows();
      this.attachEvents();
      
      // Observar mudanças de tamanho
      const resizeObserver = new ResizeObserver(() => this.updateArrows());
      resizeObserver.observe(this.container);
      
      // Observar scroll
      this.container.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    }

    attachEvents() {
      this.prevButton.addEventListener('click', () => this.navigate('prev'));
      this.nextButton.addEventListener('click', () => this.navigate('next'));

      // Add drag to scroll functionality
      let isDown = false;
      let startX;
      let scrollLeft;

      this.container.addEventListener('mousedown', (e) => {
        isDown = true;
        this.container.classList.add('active');
        startX = e.pageX - this.container.offsetLeft;
        scrollLeft = this.container.scrollLeft;
        this.container.style.scrollSnapType = 'none'; // Disable snap while dragging
        this.container.style.scrollBehavior = 'auto'; // Disable smooth scroll while dragging
      });

      this.container.addEventListener('mouseleave', () => {
        isDown = false;
        this.container.classList.remove('active');
        this.container.style.scrollSnapType = 'x mandatory';
        this.container.style.scrollBehavior = 'smooth';
      });

      this.container.addEventListener('mouseup', () => {
        isDown = false;
        this.container.classList.remove('active');
        this.container.style.scrollSnapType = 'x mandatory';
        this.container.style.scrollBehavior = 'smooth';
        // Optional: Snap to nearest slide on release if needed, 
        // but CSS scroll-snap usually handles this once snap-type is restored.
      });

      this.container.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.container.offsetLeft;
        const walk = (x - startX) * 2; //scroll-fast
        this.container.scrollLeft = scrollLeft - walk;
      });
    }

    navigate(direction) {
      const children = Array.from(this.container.children);
      const containerWidth = this.container.offsetWidth;
      
      if (direction === 'next' && this.currentIndex < children.length - 1) {
        this.currentIndex++;
      } else if (direction === 'prev' && this.currentIndex > 0) {
        this.currentIndex--;
      }
      
      this.container.scrollTo({
        left: this.currentIndex * containerWidth,
        behavior: 'smooth'
      });
    }

    updateArrows() {
      // if (window.innerWidth >= 750) {
      //   this.prevButton.style.display = 'none';
      //   this.nextButton.style.display = 'none';
      //   return;
      // }

      const scrollLeft = this.container.scrollLeft;
      const scrollWidth = this.container.scrollWidth;
      const clientWidth = this.container.clientWidth;
      
      // Calcular o índice atual baseado no scroll
      this.currentIndex = Math.round(scrollLeft / clientWidth);
      
      // Mostrar/ocultar setas baseado na posição
      if (scrollLeft <= 5) {
        this.prevButton.style.display = 'none';
        this.nextButton.style.display = scrollWidth > clientWidth ? 'flex' : 'none';
      } else if (scrollLeft + clientWidth >= scrollWidth - 5) {
        this.prevButton.style.display = 'flex';
        this.nextButton.style.display = 'none';
      } else {
        this.prevButton.style.display = 'flex';
        this.nextButton.style.display = 'flex';
      }
    }
  }

  // Inicializar para todos os containers com navegação por setas
  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-arrows-navigation]');
    containers.forEach(container => {
      new SectionArrowsNavigation(container);
    });
  });

  // Reinicializar após mudanças dinâmicas (ex: Shopify section rendering)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target.querySelector('[data-arrows-navigation]');
      if (container) {
        new SectionArrowsNavigation(container);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const muteButtons = document.querySelectorAll('[data-mute-button]');
    
    muteButtons.forEach(button => {
      const deferredMedia = button.closest('deferred-media');
      if (!deferredMedia) return;
      
      let videoElement = null;
      let iframeElement = null;
      
      // Função para obter o elemento de vídeo/iframe
      function getVideoElement() {
        if (!videoElement && !iframeElement) {
          videoElement = deferredMedia.querySelector('video');
          iframeElement = deferredMedia.querySelector('iframe');
        }
        return videoElement || iframeElement;
      }
      
      // Função para alternar mute/unmute
      function toggleMute() {
        const video = getVideoElement();
        if (!video) return;
        
        const isMuted = button.classList.contains('is-muted');
        const iconOn = button.querySelector('.video-mute-icon--on');
        const iconOff = button.querySelector('.video-mute-icon--off');
        
        if (video.tagName === 'VIDEO') {
          // Para vídeos HTML5
          video.muted = !isMuted;
        } else if (video.tagName === 'IFRAME') {
          // Para vídeos do YouTube/Vimeo via postMessage
          const src = video.src;
          
          if (src.includes('youtube.com')) {
            video.contentWindow.postMessage(
              JSON.stringify({
                event: 'command',
                func: isMuted ? 'unMute' : 'mute',
                args: []
              }),
              '*'
            );
          } else if (src.includes('vimeo.com')) {
            video.contentWindow.postMessage(
              JSON.stringify({
                method: 'setVolume',
                value: isMuted ? 1 : 0
              }),
              '*'
            );
          }
        }
        
        // Atualizar UI
        button.classList.toggle('is-muted');
        button.setAttribute('aria-label', isMuted ? 'Desativar som' : 'Ativar som');
        
        if (iconOn) iconOn.classList.toggle('hidden');
        if (iconOff) iconOff.classList.toggle('hidden');
      }
      
      // Aguardar o vídeo ser carregado quando necessário
      const observer = new MutationObserver((mutations) => {
        const video = getVideoElement();
        if (video) {
          observer.disconnect();
          
          // Se for autoplay, garantir que está mudo
          const isAutoplay = deferredMedia.hasAttribute('autoplay');
          if (isAutoplay && video.tagName === 'VIDEO') {
            video.muted = true;
          }
        }
      });
      
      observer.observe(deferredMedia, {
        childList: true,
        subtree: true
      });
      
      // Adicionar listener ao botão
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleMute();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
